import Gleap from "gleap"
import type { RouteLocationNormalizedLoaded } from "vue-router"
import { useRoute } from "vue-router"
import { hasConsented } from "./cookie-consent"
import { trackGoogleAnalyticsEvent } from "./google-analytics"
import { posthog } from "./posthog"

let route: RouteLocationNormalizedLoaded | undefined

export default function trackEvent(name: string, customData?: Record<string, any>) {
    const baseData: Record<string, any> = {}

    // `useRoute` is based on injections, so we have to "cache" its value here
    if (!route) {
        route = useRoute()
    }

    if (route?.params.campaign) {
        baseData["Campaign ID"] = route.params.campaign
    }
    if (route?.query.video) {
        baseData["Video ID"] = route.query.video
    }
    if (route) {
        baseData["Route Path"] = route.path
        baseData["Route Full Path"] = route.fullPath
        if (route.name) {
            baseData["Route Name"] = String(route.name)
        }
    }

    const data = { ...baseData, ...customData }

    try {
        window.analytics?.track(name, data)
    } catch (error) {
        console.warn(
            "An error occured while trying to submit an analytics event to Segment:",
            error,
        )
    }

    try {
        posthog.capture(name, data)
    } catch (error) {
        console.warn(
            "An error occured while trying to submit an analytics event to PostHog:",
            error,
        )
    }

    try {
        Gleap.trackEvent(name, data)
    } catch (error) {
        console.warn("An error occured while trying to submit an event to Gleap:", error)
    }

    // check consent before sending events to pixels
    if (window.fbq && hasConsented("marketing")) {
        try {
            window.fbq("trackCustom", name, data)
        } catch (error) {
            console.warn(
                "An error occured while trying to submit an event to Facebook Pixel:",
                error,
            )
        }
    }

    try {
        trackGoogleAnalyticsEvent(name, data)
    } catch (error) {
        console.warn("An error occured while trying to submit an event to gtag:", error)
    }
}
